import 'core-js/stable';
import 'regenerator-runtime/runtime.js';

/* Needed for dynamic import in IE11 (https://babeljs.io/docs/en/babel-plugin-syntax-dynamic-import/) */
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (!(Intl as any).PluralRules) {
    require('@formatjs/intl-pluralrules/polyfill');
    require('@formatjs/intl-pluralrules/locale-data/en');
    require('@formatjs/intl-pluralrules/locale-data/fr');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (!(Intl as any).RelativeTimeFormat) {
    require('@formatjs/intl-relativetimeformat/polyfill');
    require('@formatjs/intl-relativetimeformat/locale-data/en');
    require('@formatjs/intl-relativetimeformat/locale-data/fr');
}
